export default __webpack_public_path__ + "static/media/close.277eba01.svg";